var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterPattern3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05671 0.772008C11.6797 0.294007 15.9487 4.05301 15.7767 8.78301C15.6397 12.55 12.1047 16.152 8.16771 16.135C3.69071 16.115 -0.0592902 12.602 0.000710184 8.55801C0.0637099 4.35201 3.55171 0.333008 8.05671 0.772008ZM7.83871 12.108C9.69571 12.076 11.3047 10.445 11.2907 8.60901C11.2757 6.69101 9.68871 5.17101 7.79071 5.19601C5.70971 5.22401 4.45871 7.11701 4.40971 8.59301C4.34771 10.474 6.06871 12.139 7.83871 12.108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPattern3);
export default __webpack_public_path__ + "static/media/footer-pattern3.3aac28bd4da3500fa782d8a849550460.svg";
export { ForwardRef as ReactComponent };